export default "__VITE_ASSET__CLTuyYJF__"